import React, { useEffect, useRef, useState } from 'react'
import { StyledProcessingMessage } from './NewOnboarding.styles'
import aiImg from "../../../assets/images/ai-avatar.svg"
import Loaders from '../../atoms/Loaders'
import { IoCheckmark } from "react-icons/io5";

const COMPLETE_DELAY = 600

const getStepStatus = (index, currentIndex) => {
    if (index < currentIndex) return 'done'
    if (index === currentIndex) return 'active'
    return 'pending'
}

const StepIcon = ({ status }) => (
    <span className='icon'>
        {status === 'done' && <IoCheckmark color="var(--green-100)" size={20} />}
        {status === 'active' && <Loaders circleSpinner />}
    </span>
)

const StepList = ({ steps, currentIndex }) => (
    <ul className='step-list'>
        {steps?.map((label, idx) => {
            const status = getStepStatus(idx, currentIndex)
            return (
                <li key={idx} className={`step ${status}`}>
                    <StepIcon status={status} />
                    <span className='label'>{label}</span>
                </li>
            )
        })}
    </ul>
)

const useStepProgression = ({ steps, stepDuration, onComplete, loading }) => {
    const [currentIndex, setCurrentIndex] = useState(0)
    const completedRef = useRef(false)

    useEffect(() => {
        if (currentIndex >= steps.length) {
            if (completedRef.current) return undefined
            completedRef.current = true
            const timer = setTimeout(() => onComplete?.(), COMPLETE_DELAY)
            return () => clearTimeout(timer)
        }
        const isLoadingLastStep = loading && currentIndex >= steps.length - 1
        if (isLoadingLastStep) return undefined
        const timer = setTimeout(() => setCurrentIndex(prev => prev + 1), stepDuration)
        return () => clearTimeout(timer)
    }, [currentIndex, steps.length, stepDuration, onComplete, loading])

    return currentIndex
}

const ProcessingSteps = ({ title, steps, stepDuration = 1400, onComplete, loading = false, inline = false }) => {
    const currentIndex = useStepProgression({ steps, stepDuration, onComplete, loading })
    const isComplete = currentIndex >= (steps?.length || 0)

    return (
        <StyledProcessingMessage className={inline ? 'inline' : undefined}>
            {!isComplete && (
                <div className='processing-pill-wrap'>
                    <span className='processing-pill'><span>Processing...</span></span>
                </div>
            )}
            <div className='row'>
                {!inline && (
                    <div className='img-holder'>
                        <img src={aiImg} alt='aiImg' />
                    </div>
                )}
                <div className='card'>
                    <span className='card-title'>{title}</span>
                    <StepList steps={steps} currentIndex={currentIndex} />
                </div>
            </div>
        </StyledProcessingMessage>
    )
}

export default ProcessingSteps
